'use client'

import { TableSize } from '@/components/common/table-size'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { GuideNote } from './guide-note'

interface Props {
  sizeChart?: string
}
export const ProductSizeInfo = ({ sizeChart }: Props) => {
  const { product } = useProductDetailSafe()

  if (!product.size_guide) return null

  const sizeData = product.size_guide

  const isBraOrLegging = sizeChart && ['BRA', 'LEGGING'].includes(sizeChart)
  return (
    <div className='mt-4'>
      {isBraOrLegging && (
        <div className='text-base font-bold uppercase'>Thông số sản phẩm</div>
      )}

      <p className='mb-2 text-sm text-neutral-600'>
        *Là thông số sản phẩm khi trải phẳng, có thể chênh lệch so với số đo cơ
        thể do độ co giãn của vải
      </p>
      <TableSize
        rows={sizeData.rows}
        columns={sizeData.columns}
        matrix={sizeData.matrix}
        headerTitle={sizeData.headerTitle}
        leftTitle={sizeData.leftTitle}
        colClassName='min-w-32 text-start'
      />
      <GuideNote />
    </div>
  )
}
